// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__vovRb","label":"LabeledBox_label__iqa6w"};